<template>
  <div>
    <div class="table-responsive">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th scope="col" v-bind:colspan="this.colsize">
              <form v-on:submit.prevent="search()">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-bind:placeholder="Translate('@_UI_SEARCH')"
                    aria-describedby="button-theses-search"
                    ref="searchTerm"
                  />
                  <div class="input-group-append" v-if="String(filter).trim() !== ''">
                    <button
                      type="button"
                      class="btn btn-outline-danger"
                      aria-label="Close"
                      v-on:click.prevent="clearFilter()"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="input-group-append">
                    <button
                      class="btn btn-primary"
                      type="submit"
                      id="button-theses-search"
                      v-html="Translate('@_UI_SEARCH')"
                    ></button>
                  </div>
                </div>
              </form>
            </th>
          </tr>
          <tr>
            <th scope="col" v-bind:colspan="this.colsize">
              <nav class="nav nav-pills flex-column flex-sm-row">
                <a
                  class="flex-sm-fill text-sm-center nav-link"
                  v-bind:class="{ active: tag === 'all' }"
                  href="javascript: void(0);"
                  v-on:click="changeTag('all')"
                  v-html="Translate('@_ALL')"
                ></a>
                <a
                  class="flex-sm-fill text-sm-center nav-link"
                  v-bind:class="{ active: tag === 'my_thesis' }"
                  href="javascript: void(0);"
                  v-on:click="changeTag('my_thesis')"
                  v-html="Translate('@_MY_THESIS')"
                  v-if="isStudent"
                ></a>
                <a
                  class="flex-sm-fill text-sm-center nav-link"
                  v-bind:class="{ active: tag === 'my_theses' }"
                  href="javascript: void(0);"
                  v-on:click="changeTag('my_theses')"
                  v-html="Translate('@_MY_THESES')"
                  v-if="isProfessor || isAdmin"
                ></a>
                <a
                  class="flex-sm-fill text-sm-center nav-link"
                  v-bind:class="{ active: tag === 'for_approval' }"
                  href="javascript: void(0);"
                  v-on:click="changeTag('for_approval')"
                  v-html="Translate('@_FOR_APPROVAL')"
                  v-if="isProfessor || isAdmin"
                ></a>
                <a
                  class="flex-sm-fill text-sm-center nav-link"
                  v-bind:class="{ active: tag === 'for_grade' }"
                  href="javascript: void(0);"
                  v-on:click="changeTag('for_grade')"
                  v-html="Translate('@_FOR_EXAM_GRADE')"
                  v-if="isProfessor || isAdmin"
                ></a>
              </nav>
            </th>
          </tr>
          <tr>
            <th scope="col" v-bind:colspan="this.colsize">
              <select class="form-control" v-on:change="changeStatus($event)" v-if="!(tag === 'my_thesis' || tag === 'for_approval' || tag === 'for_grade')">
                <option v-bind:selected="status === 0" value="0" v-html="Translate('@_ALL')"></option>
                <option
                  v-bind:selected="status === 1"
                  value="1"
                  v-html="Translate('@_THESIS_STATUS_AVAILABLE')"
                ></option>
                <option
                  v-bind:selected="status === 2"
                  value="2"
                  v-html="Translate('@_THESIS_STATUS_TAKEN')"
                  v-if="!isStudent"
                ></option>
                <option
                  v-bind:selected="status === 3"
                  value="3"
                  v-html="Translate('@_THESIS_STATUS_PENDINGFORAPPROVAL')"
                  v-if="!isStudent"
                ></option>
                <option
                  v-bind:selected="status === 4"
                  value="4"
                  v-html="Translate('@_THESIS_STATUS_APPROVEDANDWAITINGTOPRESENT')"
                  v-if="!isStudent"
                ></option>
                <option
                  v-bind:selected="status === 5"
                  value="5"
                  v-html="Translate('@_THESIS_STATUS_PENDINGFOREXAMANDGRADING')"
                  v-if="!isStudent"
                ></option>
                <option
                  v-bind:selected="status === 6"
                  value="6"
                  v-html="Translate('@_THESIS_STATUS_COMPLETED')"
                ></option>
                <option
                  v-bind:selected="status === 7"
                  value="7"
                  v-html="Translate('@_THESIS_STATUS_CANCELED')"
                  v-if="!isStudent"
                ></option>
              </select>
            </th>
          </tr>
          <tr>
            <th :title="Translate('@_UI_SORTING_FIELD')"
            scope="col" class="cursor-pointer" v-on:click="changeSort('code')">
              <span>#</span>
              &nbsp;
              <i
                class="arrow"
                v-bind:class="{ down: sorting.dir === 'DESC', up: sorting.dir === 'ASC' }"
                v-if="sorting.field === 'code'"                
              ></i>
            </th>
            <th :title="Translate('@_UI_SORTING_FIELD')"
            scope="col" class="cursor-pointer" v-on:click="changeSort('title')">
              <span v-html="Translate('@_UI_THESIS_TITLE')"></span>
              &nbsp;
              <i
                class="arrow"
                v-bind:class="{ down: sorting.dir === 'DESC', up: sorting.dir === 'ASC' }"
                v-if="sorting.field === 'title'"
              ></i>
            </th>
            <th :title="Translate('@_UI_SORTING_FIELD')"
            scope="col" class="cursor-pointer" v-on:click="changeSort('lastname')">
              <span v-html="Translate('@_UI_THESIS_TEACHER')"></span>
              &nbsp;
              <i
                class="arrow"
                v-bind:class="{ down: sorting.dir === 'DESC', up: sorting.dir === 'ASC' }" 
                v-if="sorting.field === 'lastname'"
              ></i>
            </th>
            <th style="white-space: nowrap;" :title="Translate('@_UI_THESIS_ALLOWED_STUDENTS')+'-'+Translate('@_UI_SORTING_FIELD')"
            scope="col" class="cursor-pointer" v-on:click="changeSort('howmanystudentsallow')">
              <span v-html="Translate('@_UI_THESIS_ALLOWED_STUDENTS_MIN')" style="white-space: nowrap;"></span>
              &nbsp;
              <i
                class="arrow"
                v-bind:class="{ down: sorting.dir === 'DESC', up: sorting.dir === 'ASC' }"
                v-if="sorting.field === 'howmanystudentsallow'"
              ></i>
            </th>
            <th style="white-space: nowrap;" :title="Translate('@_UI_THESIS_TYPE')+'-'+Translate('@_UI_SORTING_FIELD')"
            scope="col" class="cursor-pointer" v-on:click="changeSort('typeofthesis')">
              <span v-html="Translate('@_UI_THESIS_TYPE_MIN')"  style="white-space: nowrap;"></span>
              &nbsp;
              <i
                class="arrow"
                v-bind:class="{ down: sorting.dir === 'DESC', up: sorting.dir === 'ASC' }"
                v-if="sorting.field === 'typeofthesis'"
              ></i>
            </th>
            <th style="white-space: nowrap;" scope="col" class="cursor-pointer" v-on:click="changeSort('status')">
              <span v-html="Translate('@_THESIS_STATUS')" style="white-space: nowrap;"></span>
              &nbsp;
              <i
                class="arrow"
                v-bind:class="{ down: sorting.dir === 'DESC', up: sorting.dir === 'ASC' }"
                v-if="sorting.field === 'status'"
              ></i>
            </th>
            <th style="white-space: nowrap;" :title="Translate('@_UI_THESIS_CREATED_DATE')+'-'+Translate('@_UI_SORTING_FIELD')"
            scope="col" class="cursor-pointer" v-on:click="changeSort('created_at')">
              <span v-html="Translate('@_UI_THESIS_CREATED_DATE_ΜΙΝ')"></span>
              &nbsp;
              <i
                class="arrow"
                v-bind:class="{ down: sorting.dir === 'DESC', up: sorting.dir === 'ASC' }"
                v-if="sorting.field === 'created_at'"
              ></i>
            </th>
            <th scope="col" v-if="tag === 'for_approval' || tag === 'for_grade'">
              <span v-html="Translate('@_THESIS_ACTION')"></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="results.length === 0">
            <td v-bind:colspan="this.colsize">
              <div
                class="alert alert-warning"
                role="alert"
                v-html="Translate('@_UI_NO_RESULTS_FOUND')"
              ></div>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr v-for="(result, index) in results" v-bind:key="index">
            <th scope="row">
              <router-link
                v-bind:to="{ name: 'thesis_view', params: { id: result.id } }"
                v-html="result.code"
              ></router-link>
            </th>
            <td v-html="result.title"></td>
            <td v-html="result.teacher1_name"></td>
            <td v-html="result.howmanystudentsallow"></td>
            <td v-html="typeOfThesisTextMin(result.typeofthesis)"></td>
            <td v-html="displayStudents(result.statustext,result.student1_name,result.student2_name)"></td>            
            <td v-html="result.created_at"></td>
            <td v-if="tag === 'for_grade'">
              <div v-if="result.teacher1_id==user.id">
                <router-link
                  v-bind:to="{ name: 'grade', params: { id: result.id } }"
                  class="col-sm btn btn-outline-success float-center"
                  tag="button"
                  v-html="Translate('@_FOR_GRADE')"
                ></router-link>
              </div>
              <div v-if="result.teacher1_id!==user.id">
                <button
                  type="button"
                  class="btn btn-outline-info"
                  v-on:click.prevent="downloadThesis(result.id,result.file, $event)"
                  v-html="Translate('@_DOWNLOAD_FILE')"
                ></button>
              </div>
            </td>
            <td v-if="tag === 'for_approval'">
              <button
                type="button"
                class="col-sm btn btn-outline-success float-center"
                v-on:click.prevent="approveThesisForExam(result.id, 1)"
                v-html="Translate('@_THESIS_ACTION_APPROVE_EXAMS')"
              ></button>
              <button
                type="button"
                class="col-sm btn btn-outline-danger float-center"
                v-on:click.prevent="approveThesisForExam(result.id, 2)"
                v-html="Translate('@_THESIS_ACTION_NOT_APPROVE_EXAMS')"
              >Δεν εγκρίνω για Εξέταση</button>
            </td>
          </tr>
        </tbody>
        <tfoot
          v-if="current_page !== null && total_pages !== null && total_results !== null && total_results !== 0"
        >
          <tr>
            <td v-bind:colspan="this.colsize">
              <nav aria-label="Page navigation">
                <ul class="pagination justify-content-end">
                  <li class="page-item" v-bind:class="{ disabled: current_page <= 1 }">
                    <a
                      class="page-link"
                      href="javascript: void(0);"
                      aria-label="Previous"
                      v-on:click="goToPage(current_page - 1)"
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only" v-html="Translate('@_UI_PREVIOUS')"></span>
                    </a>
                  </li>
                  <li
                    class="page-item"
                    v-for="page in total_pages"
                    v-bind:key="page"
                    v-bind:class="{ active: page === current_page }"
                  >
                    <a
                      class="page-link"
                      href="javascript: void(0);"
                      v-html="page"
                      v-on:click="goToPage(page)"
                    ></a>
                  </li>
                  <li class="page-item" v-bind:class="{ disabled: current_page >= total_pages }">
                    <a
                      class="page-link"
                      href="javascript: void(0);"
                      aria-label="Next"
                      v-on:click="goToPage(current_page + 1)"
                    >
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only" v-html="Translate('@_UI_NEXT')"></span>
                    </a>
                  </li>
                </ul>
              </nav>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import Mixin from "@/helpers/mixin";

export default {
  name: "ThesesTable",
  mixins: [Mixin],
  data() {
    return {
      filter: "",
      tag: "all",
      status: 0,
      sorting: {
        field: "code",
        dir: "DESC"
      },
      current_page: null,
      total_pages: null,
      results_per_page: null,
      total_results: null,
      results: [],
      colsize: 7
    };
  },
  computed: {
    __watcher_sorting_field() {
      return this.sorting.field;
    },
    __watcher_sorting_dir() {
      return this.sorting.dir;
    }
  },
  methods: {
    search() {
      let term = String(this.$refs.searchTerm.value).trim();
      this.$refs.searchTerm.value = term;
      this.filter = term;
    },
    clearFilter() {
      this.filter = "";
      this.$refs.searchTerm.value = "";
    },
    changeTag(tag) {
      this.status = 0;

      let in_tag = String(tag).trim();
      let allowed_tags = [
        "all",
        "my_thesis",
        "my_theses",
        "for_approval",
        "for_grade"
      ];
      if (allowed_tags.indexOf(in_tag) === -1) {
        this.tag = "all";
      } else {
        this.tag = in_tag;
      }
    },
    changeStatus(event) {
      let new_status = parseInt(event.target.value);
      let allowed_statuses = [1, 2, 3, 4, 5, 6, 7];
      if (allowed_statuses.indexOf(new_status) === -1) {
        this.status = 0;
      } else {
        this.status = new_status;
      }
    },
    goToPage(InPage) {
      if (InPage < 1) {
        InPage = 1;
      }
      if (InPage > this.total_pages) {
        InPage = this.total_pages;
      }
      this.current_page = InPage;
    },
    changeSort(InField) {
      let field = String(InField).trim();
      if (this.sorting.field !== field) {
        this.sorting.field = field;
        this.sorting.dir = "DESC";
      } else {
        this.sorting.dir = this.sorting.dir === "DESC" ? "ASC" : "DESC";
      }
    },
    getData(InPage, InTag, InStatus, InFilter, InSorting) {
      const _this = this;
      _this.$store
        .dispatch("http_get_theses", {
          page: parseInt(InPage),
          tag: String(InTag).trim(),
          status: String(InStatus).trim(),
          search: String(InFilter).trim(),
          order: String(InSorting.field).trim(),
          dir: String(InSorting.dir)
            .trim()
            .toUpperCase()
        })
        .then(resp => {
          _this.current_page =
            typeof resp.current_page !== "undefined"
              ? parseInt(resp.current_page)
              : 1;
          _this.total_pages =
            typeof resp.total_pages !== "undefined"
              ? parseInt(resp.total_pages)
              : 1;
          _this.results_per_page =
            typeof resp.results_per_page !== "undefined"
              ? parseInt(resp.results_per_page)
              : 1;
          _this.total_results =
            typeof resp.total_results !== "undefined"
              ? parseInt(resp.total_results)
              : 1;
          _this.results =
            typeof resp.results !== "undefined" ? resp.results : [];
        })
        .catch(e => {
          console.error(e);
        });
    },
    approveThesisForExam(thesisid, approveoption) {
      var r = confirm(this.Translate("@_ARE_YOU_SURE"));
      if (r !== true) {
        return;
      }
      this.$store
        .dispatch("http_approve_thesis_for_exam", {
          thesisid: parseInt(thesisid),
          approveoption: parseInt(approveoption)
        })
        .then(() => {
          this.getData(1, this.tag, this.status, this.filter, this.sorting);
          alert("Επιτυχής Αλλαγή");
        })
        .catch(e => {
          alert(e.bodyText);
          console.error(e);
        });
    },
    downloadThesis(id, file, event) {
      event.target.disabled = true;
      this.$store
        .dispatch("http_download_thesis", {
          thesisid: parseInt(id),
          file: file
        })
        .then(() => {
          event.target.disabled = false;
        })
        .catch(e => {
          //   event.target.disabled = false;
          //   this.ShowAlert(
          //     "alert-danger",
          //     this.Translate("@_GENERAL_ERROR"),
          //     5000
          //   );
          console.error(e);
        });
    },
    downloadThesisProposal(id, file, event) {
      event.target.disabled = true;
      this.$store
        .dispatch("http_download_thesis", {
          thesisid: parseInt(id),
          file: file
        })
        .then(() => {
          event.target.disabled = false;
        })
        .catch(e => {
          //   event.target.disabled = false;
          //   this.ShowAlert(
          //     "alert-danger",
          //     this.Translate("@_GENERAL_ERROR"),
          //     5000
          //   );
          console.error(e);
        });
    }
  },
  watch: {
    __watcher_sorting_field: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getData(1, this.tag, this.status, this.filter, this.sorting);
        }
      }
    },
    __watcher_sorting_dir: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getData(1, this.tag, this.status, this.filter, this.sorting);
        }
      }
    },
    filter: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (String(newVal).trim().length >= 3) {
            this.getData(
              1,
              this.tag,
              this.status,
              String(newVal).trim(),
              this.sorting
            );
          } else {
            this.getData(1, this.tag, this.status, "", this.sorting);
          }
        }
      }
    },
    tag: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (this.tag === "for_approval" || this.tag === "for_grade")
            this.colsize = 8;
          else this.colsize = 7;
          this.status = 0;
          this.getData(
            1,
            String(newVal).trim(),
            this.status,
            this.filter,
            this.sorting
          );
        }
      }
    },
    status: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getData(
            1,
            this.tag,
            parseInt(newVal),
            this.filter,
            this.sorting
          );
        }
      }
    },
    current_page: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getData(
            newVal,
            this.tag,
            this.status,
            this.filter,
            this.sorting
          );
        }
      }
    }
  },
  created() {
    this.getData(1, this.tag, this.status, this.filter, this.sorting);
  }
};
</script>

<style scoped>
.arrow{
    border: solid #000000;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 1px;
    margin: 0 0em 0 0em;
}
</style>
